export const USER_PERMISSIONS_LIST = [
  'Admin',
  'Status',
  'AddTags',
  'EditDeleteTags',
  'EditDeleteGroupsCategories'
];

export const USER_PERMISSIONS = USER_PERMISSIONS_LIST.reduce(
  (map, permission) => ({ ...map, [permission]: false }),
  {}
);



// WEBPACK FOOTER //
// ./src/constants/users.js